import { useContext, useCallback } from "react";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";

/**
 * Custom hook for tracking events in the Invoice module.
 * Automatically attaches user and company context and
 * standardizes the module name as "lorri invoice".
 */
export const useInvoiceMixpanelTrack = () => {
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);

  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData
  );

  /**
   * Wrapper function to simplify Invoice-related tracking calls.
   * @param {string} screen - The screen or page name
   * @param {string} definition - Description of the user action
   * @param {object|string} [data] - Optional payload data
   */
  const trackInvoiceEvent = useCallback(
    (screen, definition, data = "None") => {
      TrackMixPanel({
        ModuleName: "lorri invoice",
        ScreenName: screen,
        Data: data,
        Definition: definition,
      });
    },
    [TrackMixPanel]
  );

  return { trackInvoiceEvent };
};
